import { render, staticRenderFns } from "./question.vue?vue&type=template&id=7817ea0a&scoped=true"
import script from "./question.vue?vue&type=script&lang=js"
export * from "./question.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7817ea0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7817ea0a')) {
      api.createRecord('7817ea0a', component.options)
    } else {
      api.reload('7817ea0a', component.options)
    }
    module.hot.accept("./question.vue?vue&type=template&id=7817ea0a&scoped=true", function () {
      api.rerender('7817ea0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/storyTab/storyMaker/stiker/question.vue"
export default component.exports